import { AiOutlineHome } from "react-icons/all";
import { useHistory } from "react-router-dom";
import { useColorModeValue } from "@chakra-ui/react";

import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { Button, CustomColorScheme, IButtonProps } from "components/Button";
import { useGetThemeColors } from "ChakraTheme";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

interface IProps extends Omit<IButtonProps, "id"> {}

const MainPageButton = ({ ...restProps }: IProps) => {
  const { push } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.white, colors.black);

  return (
    <Button
      customColorScheme={CustomColorScheme.Green}
      m="auto"
      minW="200px"
      h="70px"
      leftIcon={<Icon color={iconColor} icon={AiOutlineHome} />}
      onClick={() => push(`/e-rezerwacja/${friendlyUrl}`)}
      id="main-page-btn"
      {...restProps}
    >
      <ChakraText>Strona główna</ChakraText>
    </Button>
  );
};

export { MainPageButton };
